import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import { api, dt } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, StageBadge } from "@/components/tam/ui";
import { EditSubmission } from "@/components/tam/EditSubmission";

export default function Submissions() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = useCallback(() => api.get("/activities/mine").then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="submissions-page">
      <PageHeader title={user.role === "manager" ? "All submissions" : "My submissions"} subtitle="Click any submission to update its stage, follow-up date or summary. Every change is audited." />
      <div className="bg-white border border-slate-200 rounded-md overflow-x-auto">
        <table className="w-full text-sm min-w-[820px]" data-testid="submissions-table">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500 text-left">
            <tr><th className="px-4 py-3">Logged</th><th className="px-4 py-3">Customer</th><th className="px-4 py-3">Type</th><th className="px-4 py-3">Stage</th><th className="px-4 py-3">Summary</th><th className="px-4 py-3">Follow-up</th><th /></tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} onClick={() => setEditing(a)} className="border-t border-slate-100 hover:bg-slate-50 cursor-pointer transition-colors" data-testid={`submission-row-${a.id}`}>
                <td className="px-4 py-3 text-xs whitespace-nowrap">{dt(a.created_at)}{user.role === "manager" && <p className="text-slate-500">{a.user_name}</p>}</td>
                <td className="px-4 py-3"><Link to={`/accounts/${a.account_id}`} onClick={(e) => e.stopPropagation()} className="font-medium hover:text-[#D9232A]">{a.account_name}</Link></td>
                <td className="px-4 py-3 text-xs">{a.channel}</td>
                <td className="px-4 py-3"><StageBadge stage={a.stage} /></td>
                <td className="px-4 py-3 text-xs max-w-[320px] truncate">{a.summary}{a.edits?.length ? <span className="text-slate-400"> · edited</span> : ""}</td>
                <td className="px-4 py-3 text-xs font-mono">{a.follow_up_date || "—"}</td>
                <td className="px-4 py-3 text-right"><Pencil size={14} className="text-slate-400 inline" /></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-500" data-testid="submissions-empty">No submissions yet.</td></tr>}
          </tbody>
        </table>
      </div>
      <EditSubmission activity={editing} onClose={() => setEditing(null)} onSaved={load} />
    </div>
  );
}
